import React from "react";
import { service } from "../Data/data"; // ✅ Adjust path as needed
import { Link } from "react-router-dom";
import MetaManager from "../Layout/MetaManager"; // ✅ Adjust path if needed

const Services = () => {
  return (
    <>
      {/* ✅ MetaManager for dynamic SEO tags */}
      <MetaManager slug="services" />

      <div className="py-10 px-4 sm:px-8 lg:px-16 bg-gray-50">
        <h2 className="text-3xl font-bold text-center mb-10 text-gray-800">
          Our Services
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {service.map((item, index) => (
            <div
              key={index}
              className="bg-white shadow-md rounded-xl overflow-hidden transition-transform transform hover:scale-105"
              style={{ backgroundColor: "rgb(138 252 251 / 20%)" }}
            >
              <img
                src={item.image}
                alt={item.name}
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-2 text-gray-900">
                  {item.name}
                </h3>
                <p className="text-sm text-gray-700 mb-4 line-clamp-4">
                  {item.description}
                </p>
                <Link to={`/service/${item.slug}`}>
                  <button className="mt-2 text-sm text-indigo-600 hover:underline font-medium">
                    {item.getACall}
                  </button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Services;
